<template>
  <div class="user">
    <UserAvatar
      :user="user"
      size="sm"
      class="user__avatar mr-2" />
    <div
      class="user__name mr-2"
      :class="{ selected }">
      {{ user.name }}
    </div>
    <slot>
      <div class="user__position">
        {{ user.position }}
      </div>
    </slot>
  </div>
</template>

<script>
import UserAvatar from '@/components/parts/UserAvatar.vue'
export default {
  components: {
    UserAvatar
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.user {
  display: flex;
  align-items: center;

  &__name {
    font-weight: bold;
    font-size: $fs-m;

    &.selected {
      border-bottom: 4px solid $l-blue;
    }
  }

  &__position {
    font-size: $fs-s;
  }
}
</style>